import React from 'react';

const FinancialSVG = ({ width, height }) => (
	<svg
		width={width || '44px'}
		height={height || '58px'}
		viewBox="0 0 44 58"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>7A8FFA8D-5AF7-481A-ACF0-FEB00C5DA50A@1x</title>
		<desc>Created with sketchtool.</desc>
		<g
			id="NEW-2"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Services"
				transform="translate(-281.000000, -2819.000000)"
				fill="#32C878"
				fill-rule="nonzero"
			>
				<g id="Group-19" transform="translate(230.000000, 2811.000000)">
					<g
						id="noun_receipt_550629"
						transform="translate(52.000000, 8.000000)"
					>
						<g id="Group">
							<g id="Group-8">
								<g>
									<g transform="translate(0.000000, 0.982233)">
										<path
											d="M32.5090617,35.8030452 C33.8024392,35.4902185 34.957913,34.7546647 35.5693247,33.4624087 C36.818952,30.8212457 35.5631857,28.958903 32.8913977,27.5639327 C32.507309,27.3633957 32.6217022,27.4170615 31.5316867,26.9143035 C30.5216775,26.4489025 30.6090872,26.4899085 30.2788872,26.3170795 C28.6562632,25.467787 28.2069462,24.7976125 28.7203127,23.7125815 C29.35106,22.3794585 32.235113,22.4591571 33.2475015,23.1771357 L34.2671187,23.9002405 L35.7133287,21.8610062 L34.6937115,21.1379012 C34.118174,20.7297343 33.350595,20.4237803 32.5090617,20.2589914 L32.5090617,18.017767 L30.0090617,18.017767 L30.0090617,20.2053628 C28.5232762,20.441178 27.14796,21.1903659 26.4604882,22.643379 C25.2138635,25.2781962 26.463231,27.1416787 29.1195695,28.5320247 C29.5062515,28.7344167 29.413997,28.691138 30.485023,29.1846547 C31.513319,29.6589455 31.405414,29.6083235 31.7343347,29.7800567 C33.3712027,30.6346837 33.8238842,31.3060252 33.3095005,32.3932062 C32.678753,33.7263292 29.7947002,33.6466305 28.7823115,32.928652 L27.7626942,32.205547 L26.3164845,34.2447815 L27.3361017,34.9678865 C28.0213097,35.453831 28.978721,35.7948972 30.0090617,35.9253527 L30.0090617,38.017767 L32.5090617,38.017767 L32.5090617,35.8030452 Z"
											id="Path"
										/>
										<rect
											id="Rectangle"
											x="7.5"
											y="15.517767"
											width="12.5"
											height="3"
										/>
										<rect
											id="Rectangle"
											x="7.5"
											y="23.017767"
											width="12.5"
											height="3"
										/>
										<rect
											id="Rectangle"
											x="7.5"
											y="30.517767"
											width="12.5"
											height="3"
										/>
										<rect
											id="Rectangle"
											x="7.5"
											y="38.017767"
											width="12.5"
											height="3"
										/>
										<path
											d="M41.25,1.98063788e-13 L42.5,1.25 L42.499,1.767 L42.5,1.76776695 L42.5,49.267767 L42.499,49.267 L42.5,49.785534 L38.017767,54.267767 L36.25,56.035534 L36.25,56.035534 L34.482233,54.267767 L31.25,51.035 L26.25,56.035534 L21.25,51.035 L16.25,56.035534 L11.25,51.035 L6.25,56.035534 L8.10906897e-13,49.785534 L8.10906897e-13,1.25 L1.25,1.98063788e-13 L6.25,5 L9.483,1.768 L9.48223305,1.76776695 L11.25,1.98063788e-13 L16.25,5 L21.25,6.30606678e-14 L21.25,1.98063788e-13 L26.25,5 L29.483,1.768 L29.482233,1.76776695 L31.25,1.98063788e-13 L36.25,5 L41.25,1.98063788e-13 Z M16.25,8.5355339 L14.482233,6.76776695 L11.25,3.535 L6.25,8.5355339 L2.5,4.785 L2.5,48.749 L6.25,52.499 L11.25,47.5 L16.25,52.499 L21.25,47.5 L26.25,52.499 L31.25,47.5 L36.249,52.499 L40,48.748 L40,4.784 L38.017767,6.76776695 L36.25,8.5355339 L36.25,8.5355339 L34.482233,6.76776695 L31.25,3.535 L26.25,8.5355339 L21.25,3.535 L18.017767,6.76776695 L16.25,8.5355339 L16.25,8.5355339 Z"
											id="Combined-Shape"
											stroke="#32C878"
											stroke-width="0.7"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default FinancialSVG;
